import { PtTopicPage } from '../../../components/market/PtTopicPage'
import { getPtPageProps } from '../../../lib/market-pages'
import content from '../../../data/markets/ae/pt/abu-dhabi/freelance-personal-trainer'

// Generated by scripts/generate-market-pages.mjs. Bump CONTENT_REVIEWED by
// hand when the copy in the content module changes (feeds dateModified).
const CONTENT_REVIEWED = '2026-10-03'

export const getStaticProps = () => getPtPageProps('ae', 'abu-dhabi', CONTENT_REVIEWED)

export default function Page(props) {
    return <PtTopicPage {...props} content={content} />
}
